import { useContext, type ReactNode } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { can, type Permission } from './policy';

interface CanProps {
  do: Permission;
  fallback?: ReactNode;
  children: ReactNode;
}

export function Can({ do: permission, fallback = null, children }: CanProps) {
  const ctx = useContext(AuthContext);
  const role = ctx?.user?.role ?? null;
  return <>{can(role, permission) ? children : fallback}</>;
}
